import React, {Component} from 'react';
import {Grid, Row, Col, FormGroup, ControlLabel, Form, FormControl, ButtonToolbar} from "react-bootstrap";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import moment from "moment";
import DataAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import OrlenWyslanieFaktury from "./OrlenWyslanieFaktury";


export default class OrlenSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: '',
            dataDo: '',
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
    }

    componentDidMount() {
        // let now = moment();
        // let obecny_rok = (now.year());
        // let poprzedni_miesiac = (now.month());

        // let pierwszy_miesiaca = moment(obecny_rok + '-' + poprzedni_miesiac + '-01')
        let pierwszy_miesiaca = moment().subtract(1, "month").startOf('month')

        // let ostatni_miesiaca = moment(obecny_rok + '-' + poprzedni_miesiac + '-' + moment(poprzedni_miesiac).daysInMonth())
        let ostatni_miesiaca = moment().endOf('month')

        this.setState({
            dataOd: (pierwszy_miesiaca),
            dataDo: (ostatni_miesiaca),
        })
    }

    componentWillReceiveProps(nextprops) {
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onClickSzukaj(czyPobracDane = false) {
        if (Boolean(this.state.dataOd) && Boolean(this.state.dataOd)) {
            if (DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo) >= DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd)) {
                if (czyPobracDane) {
                    if (window.confirm('Czy na pewno chcesz pobrać dane z okresu ' + DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd) + ' - ' + DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo))) {
                        this.props.handleClickDownload({
                            dataOd: DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                            dataDo: DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                        })
                    }
                }
                else {
                    this.props.handleClickSearch({
                        dataOd: DataAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                        dataDo: DataAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                    })
                }
            } else {
                alert('Podano nieprawidłowy zakres dat!')
            }
        }else{
            alert("Proszę uzupełnić daty!")
        }

    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup style={{marginBottom: '0'}}>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Data transakcji od <span style={{color: 'red'}}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={6} lg={2}>
                            <ControlLabel>Data transakcji do <span style={{color: 'red'}}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={12} lg={3}>
                            <div className={'add-label-margin'}></div>
                            <ButtonToolbar>
                                <TopButtonAction text={'Szukaj danych'} iconType={'fa fa-search'} btnSize={'md'} btnColor={'primary'}
                                                 onClick={() => this.onClickSzukaj(false)}/>
                                <TopButtonAction text={'Pobierz dane z Orlenu'} iconType={'fa fa-download'} btnSize={'md'} btnColor={'warning'}
                                                 onClick={() => this.onClickSzukaj(true)}/>
                            </ButtonToolbar>
                        </Col>
                        <Col xs={12} lg={5}>
                            <OrlenWyslanieFaktury faktury={this.props.fakturyWysylkaSelect} handleOdswiezNumeryFaktur={()=>{this.props.handleOdswiezNumeryFaktur()}}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/Orlen/components/OrlenSearchbox.js